
import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const LinkedInIconSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.4827 4.65234H1.21191V11.9924H3.4827V4.65234Z"
      fill="currentColor"
    />
    <path
      d="M2.33695 3.67171C2.60518 3.67383 2.86799 3.59622 3.09204 3.44873C3.31609 3.30125 3.49129 3.09054 3.5954 2.84333C3.69952 2.59612 3.72785 2.32356 3.67682 2.06022C3.62579 1.79689 3.49769 1.55464 3.30877 1.36422C3.11985 1.1738 2.87862 1.04379 2.61569 0.990674C2.35277 0.937562 2.07999 0.963745 1.83197 1.0659C1.58395 1.16806 1.37186 1.34158 1.22261 1.56446C1.07336 1.78734 0.993671 2.04953 0.993663 2.31777C0.992962 2.49487 1.02715 2.67038 1.09428 2.83427C1.1614 2.99816 1.26015 3.14722 1.38489 3.27295C1.50963 3.39867 1.6579 3.4986 1.82126 3.56702C1.98461 3.63544 2.15984 3.67102 2.33695 3.67171Z"
      fill="currentColor"
    />
    <path
      d="M7.11816 8.1438C7.11816 7.10969 7.59257 6.49668 8.50409 6.49668C9.4156 6.49668 9.74076 7.08304 9.74076 8.1438V11.9977H12.0009V7.34956C12.0009 5.38261 10.8868 4.42845 9.33564 4.42845C8.89331 4.42251 8.45699 4.53136 8.06927 4.74437C7.68156 4.95738 7.3557 5.26727 7.12349 5.64381V4.65233H4.93799V11.9977H7.11816V8.1438Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkedInIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LinkedInIconSvg} {...props} />
);
